module.exports = __webpack_public_path__ + "static/img/tongbanzhi-2.e8ed176.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tongbanzhi-2.jpg
// module id = m5tZ
// module chunks = 2